import React from 'react';
import { WebsiteDesignProps } from './types';
import { Smile, Heart, Star } from 'lucide-react';
import { Button } from "@/components/ui/button";

const ClayPlay: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Play Dough Preschool";

    return (
        <div className="bg-[#ffe4e6] min-h-screen font-sans text-[#4a4a4a]">
            <nav className="p-8 flex justify-between items-center">
                <div className="text-3xl font-black text-white px-6 py-2 rounded-full bg-[#ff7eb3] shadow-[inset_-4px_-4px_10px_rgba(0,0,0,0.1),inset_4px_4px_10px_rgba(255,255,255,0.4),8px_8px_16px_rgba(255,100,100,0.2)]">
                    {schoolName}
                </div>
                <div className="flex gap-4">
                    <Button className="bg-[#7afcff] text-[#006064] hover:bg-[#4de1e6] rounded-3xl px-8 font-bold shadow-[8px_8px_16px_rgba(0,180,180,0.2),-4px_-4px_10px_rgba(255,255,255,0.8)] border-4 border-white">
                        Join Us
                    </Button>
                </div>
            </nav>

            <main className="container mx-auto px-6 py-12 flex flex-col items-center">
                 <div className="bg-[#fff0f5] p-12 rounded-[3rem] shadow-[20px_20px_40px_#ffccd5,-20px_-20px_40px_#ffffff] text-center max-w-3xl mb-16">
                     <h1 className="text-5xl md:text-7xl font-black text-[#ff7eb3] mb-6 drop-shadow-sm tracking-tight">
                         Soft. Safe. <br/> Super Fun.
                     </h1>
                     <p className="text-xl text-gray-500 mb-8 font-bold">
                         A world that feels like a hug. Learning through tactile play and imagination.
                     </p>
                     
                     <div className="flex justify-center gap-6">
                         <div className="w-32 h-32 bg-[#ffcbf2] rounded-full shadow-[inset_-6px_-6px_10px_rgba(0,0,0,0.05),inset_6px_6px_10px_rgba(255,255,255,0.6),10px_10px_20px_rgba(0,0,0,0.05)] flex items-center justify-center transform rotate-12">
                             <Smile className="text-white w-16 h-16" />
                         </div>
                         <div className="w-32 h-32 bg-[#a2d2ff] rounded-full shadow-[inset_-6px_-6px_10px_rgba(0,0,0,0.05),inset_6px_6px_10px_rgba(255,255,255,0.6),10px_10px_20px_rgba(0,0,0,0.05)] flex items-center justify-center transform -rotate-6 mt-8">
                             <Star className="text-white w-16 h-16" />
                         </div>
                         <div className="w-32 h-32 bg-[#bde0fe] rounded-full shadow-[inset_-6px_-6px_10px_rgba(0,0,0,0.05),inset_6px_6px_10px_rgba(255,255,255,0.6),10px_10px_20px_rgba(0,0,0,0.05)] flex items-center justify-center transform rotate-6">
                             <Heart className="text-white w-16 h-16" />
                         </div>
                     </div>
                 </div>

                 <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-4xl">
                     <div className="bg-[#cdb4db] p-8 rounded-[2rem] shadow-[10px_10px_20px_rgba(100,50,100,0.1)] text-white font-bold text-center">
                         <h3 className="text-2xl mb-4">Creative Arts</h3>
                         <p className="opacity-80">Painting, molding, and making messes!</p>
                     </div>
                     <div className="bg-[#ffafcc] p-8 rounded-[2rem] shadow-[10px_10px_20px_rgba(200,50,50,0.1)] text-white font-bold text-center">
                         <h3 className="text-2xl mb-4">Story Time</h3>
                         <p className="opacity-80">Adventures in every book we open.</p>
                     </div>
                 </div>
            </main>
        </div>
    );
};

export default ClayPlay;
